import React from 'react'
import PropTypes from 'prop-types'

const BulkEditFooter = ({ disabled, isSubmitting, resourceCount, onApply, onCancel }) => (
  <div className="border-top p-3 d-flex justify-content-end">
    <button
      type="button"
      className="btn btn-outline-light text-dark border border-muted"
      disabled={isSubmitting}
      onClick={onCancel}
    >
      Annuler
    </button>
    <button
      type="button"
      className="btn btn-success ml-2"
      disabled={disabled || isSubmitting}
      onClick={onApply}
    >
      {isSubmitting ? 'Application...' : `Appliquer sur ${resourceCount}`}
    </button>
  </div>
)

BulkEditFooter.propTypes = {
  disabled: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onApply: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  resourceCount: PropTypes.string.isRequired
}

export default BulkEditFooter
